import { render, staticRenderFns } from "./mispedidosActivos.vue?vue&type=template&id=29892b92&scoped=true&"
import script from "./mispedidosActivos.vue?vue&type=script&lang=js&"
export * from "./mispedidosActivos.vue?vue&type=script&lang=js&"
import style0 from "./mispedidosActivos.vue?vue&type=style&index=0&id=29892b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29892b92",
  null
  
)

export default component.exports